@use '@/styles/tokens' as *;

/* Matches WarrantyClaimsGrid (warranty-claims-grid.module.scss). */
.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-5);

  @include up('sm') {
    grid-template-columns: repeat(2, 1fr);
  }

  @include up('lg') {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Matches WarrantyClaimCard `.card` shape (warranty-claim-card.module.scss). */
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-6) var(--space-5) var(--space-5);
  background: var(--surface-muted, #{$color-neutral-100});
  border: 1px solid transparent;
  border-radius: 16px;
}

.imageWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 132px;
}
